export const API_URL = process.env.VUE_APP_API_URL
export const ASSETS_URL = process.env.VUE_APP_ASSETS_URL
